import { render, staticRenderFns } from "./addEdit-document.vue?vue&type=template&id=9c46c438&scoped=true"
import script from "./addEdit-document.vue?vue&type=script&lang=js"
export * from "./addEdit-document.vue?vue&type=script&lang=js"
import style0 from "./addEdit-document.vue?vue&type=style&index=0&id=9c46c438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c46c438",
  null
  
)

export default component.exports